import { render } from "./UpdateEmployeePage.vue?vue&type=template&id=52a7a7d4&ts=true"
import script from "./UpdateEmployeePage.vue?vue&type=script&lang=ts"
export * from "./UpdateEmployeePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__